export default "__VITE_ASSET__97mzDKb6__"